import { ICardMotorsportsResults, formatTiming, ITiming } from '@sky-it-livedata/livedata-sports-design-system';
import {
  truncateNameWithDot,
  uppercaseFirstCharInText,
} from '@sky-it-livedata-libraries/livedata-commons';
import { DataCardGpResultsQuery } from '../types';
import { isValidDataCardGpResults } from './typeguards';
import { ErrorName, WidgetError } from '../../../utils/errors';
import { intcmpMap } from '../../../utils/intcmp';
import { CardGpResultsResultInfo, CreateCardGpResultsWidgetInputSchema } from 'appsync';
import { competitionNameMap } from '../../../types/data-cards';

const getGapLabel = ({ gap, pos }: Pick<CardGpResultsResultInfo, 'gap' | 'pos'>): string =>
  gap === '-' || gap === '' ? gap : `${pos === '-' ? '' : '+'}${gap}`;


export default (obj: DataCardGpResultsQuery): ICardMotorsportsResults => {
  if (isValidDataCardGpResults(obj)) {
      CreateCardGpResultsWidgetInputSchema().parse(obj.data.getCardGpResultsWidget, {reportInput: true});
      const { results, customCompetitionName, isSprint, competitionId, customGpName, resultsLink } = obj?.data?.getCardGpResultsWidget;

      return {
        competitionId,
        customGpName,
        resultsLink,
        isSprint,
        customCompetitionName: competitionNameMap.get(customCompetitionName),
        results: results?.map((resultObj, index: number) => {
          const result = resultObj as CardGpResultsResultInfo;

          return {
            customDriverPageUrl: result.customDriverPageUrl,
            flagUrl: result.flagUrl,
            driverName: `${uppercaseFirstCharInText(result.customDriverSurname as string)} ${truncateNameWithDot(
              (result.customDriverName as string).toUpperCase()
            )}`,
            position: result.pos,
            result: index === 0 ? formatTiming(result.timing as ITiming) : getGapLabel({ gap: result.gap, pos: result.pos }),
            targetUrl: result.customDriverPageUrl,
            trackingData: { intcmp: intcmpMap.dataCardGpResults.detailLink },
          };
        }),
        trackingData: { 'analytics-element': 'card-results-motorsport-formula1' },
        cardCtaTrackingData: {
          intcmp: intcmpMap.dataCardGpResults.viewAllCta,
        },
      } as ICardMotorsportsResults;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in DataCardGpResultsQuery object',
      data: obj
    });
  }
};
